import { render, staticRenderFns } from "./ConfirmSplitting.vue?vue&type=template&id=76f2f307"
import script from "./ConfirmSplitting.vue?vue&type=script&lang=js"
export * from "./ConfirmSplitting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports